// Del paquete que arma la IA a lo que muestra la vista previa (la misma EventPage que verá el público).
import type { EventPackage, Section } from '@cuorum/contracts/ai-package';
import type { EventPageData, EventStyle } from '@cuorum/ui';
import { localToInstant } from '../../lib/zonedTime.ts';

export interface DemoAccount { id: string; slug: string; name: string; initials: string; accentColor: string }

/** Cuenta de demostración mientras el login del organizador (F0a) no esté listo. Ficticia. */
export const DEMO_ACCOUNT: DemoAccount = {
  id: '00000000-0000-4000-8000-0000000000ca', slug: 'ciudad-abierta', name: 'Corporación Ciudad Abierta', initials: 'CA', accentColor: '#2F5BEA',
};

export const SECTION_LABEL: Record<Section, string> = {
  event: 'Página del evento',
  agenda: 'Programa',
  registration: 'Inscripción',
  emails: 'Correos y recordatorios',
  live: 'Sala en vivo',
  style: 'Estilo sugerido',
  review: 'Lo que falta confirmar',
};

export interface Draft {
  pkg: EventPackage;
  style: EventStyle;
  accent: string;
  motion: boolean;
}

export function draftToPage(d: Draft, account: DemoAccount): EventPageData {
  const e = d.pkg.event;
  const startsAt = e.startsAt ? localToInstant(e.startsAt, e.timeZone) : null;
  const endsAt = e.endsAt ? localToInstant(e.endsAt, e.timeZone) : startsAt ? new Date(Date.parse(startsAt) + 2 * 3600_000).toISOString() : null;
  const tools = d.pkg.live.items.map((i) => (i.kind === 'questions' ? 'questions' : i.kind)) as EventPageData['participation'];
  return {
    title: e.title,
    kicker: e.kicker,
    summary: e.summary,
    startsAt,
    endsAt,
    timeZone: e.timeZone,
    venue: { name: e.venue.name, address: e.venue.address, note: null, mapUrl: null },
    organizer: { name: account.name, initials: account.initials, tagline: null },
    about: e.about,
    agenda: d.pkg.agenda,
    participation: [...new Set(tools)],
    accessibility: [],
    capacity: e.capacity ? { total: e.capacity, taken: 0 } : null,
    registration: 'open',
    coverImageUrl: null,
    privacyUrl: `/${account.slug}/privacidad`,
  };
}
